export { default } from "./app-chips.component";
export * from "./app-chips.types";
